const state = {
  cid: localStorage.getItem('cid') || null,
  branding: JSON.parse(localStorage.getItem('branding') || 'null'),
  user: localStorage.getItem('uid') || null,
  loaded: false
}

const getters = {
  cid: state => state.cid,
  branding: state => state.branding,
  user: state => state.user,
  loaded: state => {
    if (state.cid && state.user) {
      return true
    } else {
      return false
    }
  }
}

const mutations = {
  mutateCustId (state, _cid) {
    localStorage.setItem('cid', _cid)
    state.cid = _cid
  },
  mutateBrand (state, _brand) {
    localStorage.setItem('branding', JSON.stringify(_brand))
    state.branding = _brand
  },
  mutateUser (state, _user) {
    localStorage.setItem('uid', _user)
    state.user = _user
  },
  mutateLoaded(state, _bool) {
    state.loaded = _bool
  }
}

const actions = {
  setCustId ({commit}, _cid) {
    commit('mutateCustId', _cid)
  },
  setBrand ({commit}, _brand) {
    commit('mutateBrand', _brand)
  },
  setLoaded ({commit}, _bool) {
    commit('mutateLoaded', _bool)
  },
  setUser ({commit}, _user) {
    commit('mutateUser', _user)
  }
 }

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}